import { render, staticRenderFns } from "./LinkedProjects.vue?vue&type=template&id=0b96c9a2&"
import script from "./LinkedProjects.vue?vue&type=script&lang=js&"
export * from "./LinkedProjects.vue?vue&type=script&lang=js&"
import style0 from "./LinkedProjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports